<template lang="pug">
  
  //- .list
  draggable.list(
    :group="{ name: 'traffic', pull: pullFunction }"
    handle=".content"
    v-model="items"
    :clone="cloneTask"
    :disabled="!enabled"
    :class="{collapsed: collapsed, draggable: enabled}"
  )
    template(v-for="data, k in items")
      task-cell(v-if="data.id" :item="data" @click="$emit('edit', {data})" :collapsed="collapsed")
      administration(v-else-if="data.administration" :item="data" :collapsed="collapsed")
      supervisor(v-else-if="data.supervisor" :item="data" :collapsed="collapsed")
      creative(v-else-if="data.creative" :item="data" :collapsed="collapsed")
      empty(v-else :item="data" @click.native="$emit('edit', {data})" :collapsed="collapsed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import Empty from './Empty'
import Administration from './Administration'
import Supervisor from './Supervisor'
import Creative from './Creative'
import TaskCell from './TaskCell'
import Task from '../../store/models/Task'
import User from '../../store/models/User'

export default {

  name: 'traffic-day',

  components: {
    Empty,
    Administration,
    Supervisor,
    Creative,
    TaskCell,
    draggable,
  },

  props: {
    collapsed: Boolean,
    user: {
      type: User,
      required: true
    },
    day: {
      type: Number,
      required: true,
    }
  },

  computed: {
    ...mapGetters('traffic', [
      'cloneMode',
      'dayTasksByUser',
      'slots',
      'traffic',
    ]),
    enabled() {
      return !this.collapsed && !window.matchMedia(`(max-width: 959px)`).matches
    },
    items: {
      get() {
        return this.dayTasksByUser(this.user, this.day)
      },
      set(items) {
        this.moveTasks({ tasks: items, day: this.day })
            // .then(response => this.resetList())
            // .catch(failed => this.resetList())
      }
    },
  },

  mounted() {
    this.$el.day = this
    this.id = `${this.$moment(this.day).format('YYYY-MM-DD')}_${this.user.id}`
  },

  methods: {
    ...mapActions('traffic', [
      'moveTasks',
    ]),
    cloneTask(task) {
      if(this.cloneMode) task = task.duplicate()
      return task
    },
    pullFunction() {
      return this.cloneMode ? 'clone' : true
    },
  },
}
</script>